module.exports = __webpack_public_path__ + "static/media/vilnius-11.3acad9e1.jpg";